import type { ReactElement } from 'react'

interface ConfirmationModalProps {
    readonly isOpen: boolean
    readonly title: string
    readonly message: string
    readonly confirmLabel?: string
    readonly cancelLabel?: string
    readonly onConfirm: () => void
    readonly onCancel: () => void
}

export function ConfirmationModal({
    isOpen,
    title,
    message,
    confirmLabel = 'Continue',
    cancelLabel = 'Cancel',
    onConfirm,
    onCancel
}: ConfirmationModalProps): ReactElement | null {
    if (!isOpen) {
        return null
    }

    return (
        <div
            className='fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm'
            role='dialog'
            aria-modal='true'
            aria-labelledby='modal-title'
        >
            <div className='mx-4 w-full max-w-md rounded-lg border border-slate-700 bg-slate-900 p-6 shadow-xl'>
                <h2 id='modal-title' className='text-lg font-semibold text-white'>
                    {title}
                </h2>
                <p className='mt-3 text-sm text-slate-300'>{message}</p>
                <div className='mt-6 flex justify-end gap-3'>
                    <button
                        type='button'
                        onClick={onCancel}
                        className='rounded-md border border-slate-600 bg-slate-800 px-4 py-2 text-sm font-medium text-slate-200 transition hover:bg-slate-700'
                    >
                        {cancelLabel}
                    </button>
                    <button
                        type='button'
                        onClick={onConfirm}
                        className='rounded-md bg-sky-600 px-4 py-2 text-sm font-medium text-white transition hover:bg-sky-500'
                    >
                        {confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    )
}
